import { useTranslation } from 'react-i18next';

import { FieldComponent, Toggle } from 'libs/form';
import { Help } from 'libs/ui';
import { ZoneInputBox } from '../styled';
import { weekdayRows, holidayRow } from './weekday.config';
import { Interface, Wrapper, Row, RowLabel, ToggleCell, Divider, HeaderCell, FieldCell } from './weekday.styled';

// block paste of a value with anything but digits
const onlyDigitsPaste = (e) => {
  const text = e.clipboardData?.getData('text') ?? '';
  if (!/^\d*$/.test(text)) {
    e.preventDefault();
  }
};

const ToggleRow = ({ name, label, hint, disabled }) => (
  <Row className="toggle">
    <RowLabel>{label}</RowLabel>
    <ToggleCell>
      <Toggle className="black" name={name} type="toggle" disabled={disabled} />
      <Help className="white" info={hint} />
    </ToggleCell>
  </Row>
);

const DayRow = ({ prefix, label, disabled, t }) => (
  <Row>
    <RowLabel>{label}</RowLabel>
    <FieldCell onPasteCapture={onlyDigitsPaste}>
      <ZoneInputBox wide style={{ width: '100%' }}>
        <FieldComponent disabled={disabled} name={`${prefix}_hour_cost`} title={t('form.Стоимость, Р')} type="text" naturalNumber withZero maxValueLength={8} />
      </ZoneInputBox>
    </FieldCell>
    <FieldCell onPasteCapture={onlyDigitsPaste}>
      <ZoneInputBox wide style={{ width: '100%' }}>
        <FieldComponent
          disabled={disabled}
          name={`${prefix}_free_interval`}
          title={t('form.Бесплатное время')}
          type="text"
          naturalNumber
          withZero
          maxValueLength={8}
          mask={{ suffix: t('form.мин') }}
        />
      </ZoneInputBox>
    </FieldCell>
  </Row>
);

export const WeekdayTariffication = (props) => {
  const { color, display, disabled } = props;
  const { t } = useTranslation();

  return (
    <Interface color={color} style={{ display: display ? 'block' : 'none' }}>
      <Wrapper>
        <ToggleRow name="use_freeperiod" label={t('form.Тарификация бесплатного времени')} hint={t('tariffs.Тарификация бесплатного времени помощь дни недели')} disabled={disabled} />
        <ToggleRow name="use_first_paid_day" label={t('form.Отсчёт с первого платного дня')} hint={t('tariffs.Отсчёт с первого платного дня помощь')} disabled={disabled} />
        <Divider />
        <Row>
          <div />
          <HeaderCell>{t('form.Стоимость, Р')}</HeaderCell>
          <HeaderCell className="right">
            <span>{t('form.Бесплатное время')}</span>
            <Help className="white nowrap" w="0px" info={t('tariffs.Бесплатное время помощь дни недели')} />
          </HeaderCell>
        </Row>
        {weekdayRows.map((row) => (
          <DayRow key={row.prefix} prefix={row.prefix} label={t(`form.${row.label}`)} disabled={disabled} t={t} />
        ))}
        <Divider />
        <ToggleRow name="use_holidays" label={t('form.Учитывать праздничные дни')} hint={t('tariffs.Учитывать праздничные дни помощь')} disabled={disabled} />
        <DayRow prefix={holidayRow.prefix} label={t(`form.${holidayRow.label}`)} disabled={disabled} t={t} />
      </Wrapper>
    </Interface>
  );
};
